// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"64":"91acfdb0","116":"b981ebfa","171":"d1186e67","201":"1328741d","359":"aab7e171","824":"cb0337a6","840":"1463b11c","940":"8d32d2f0","995":"e4f3d7f8"}[chunkId] + ".js";
};